var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12504 2.87835L9.86129 13.0733C10.0021 13.2376 10.1768 13.3694 10.3734 13.4598C10.5699 13.5502 10.7837 13.597 11 13.597C11.2164 13.597 11.4302 13.5502 11.6267 13.4598C11.8233 13.3694 11.998 13.2376 12.1388 13.0733L20.875 2.87835C21.7088 1.90522 21.0175 0.4021 19.7363 0.4021H2.26129C0.980044 0.4021 0.288794 1.90522 1.12504 2.87835Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.4a97dcfe54398e7f807937c77937d2f9.svg";
export { ForwardRef as ReactComponent };